function isFakeNews(newsTitle: string): boolean {
  return newsTitle.includes('d');
}

export { isFakeNews };
